import { useMutation } from "@tanstack/react-query";

import { mainApi } from "../../../../api";

export const useNewChildCodeResend = () => {
    return useMutation(() =>
        mainApi.post("resend_new_child_registered_email_to_parent")
    );
};
